import { Select } from 'antd'
import { MetadataOption } from 'api'
import React, { useState } from 'react'
import './index.less'

export interface AppSelectProps {
  value?: string
  onChange?: (value: string, text: string) => void
  placeholder?: string
  readonly?: boolean
  options?: MetadataOption[]
  error?: boolean
}

const getText = (value?: string, options?: MetadataOption[]) => {
  let option = options.find(o => o.value === value) || { label: '' }
  return option.label || ''
}

const initState = (props: AppSelectProps) => {
  if (props.readonly) return 'readonly'
  if (props.error) return 'error'
  return 'default'
}

export const AppSelect = (props: AppSelectProps) => {
  const [value, setValue] = useState(props.value)
  const [state, setState] = useState(initState(props))

  const handleChang = (newValue: string) => {
    props.onChange && props.onChange(newValue, getText(newValue, props.options))
    setState('default')
    setValue(newValue)
  }

  return (
    <div className="app-select-container" data-state={state}>
      <Select
        placeholder={props.placeholder || ''}
        value={value}
        onChange={handleChang}
        style={{ width: '100%' }}
        disabled={props.readonly || false}
      >
        {props.options &&
          props.options.map((option: MetadataOption) => {
            return (
              <Select.Option key={option.value} value={option.value} title={option.label}>
                {option.label}
              </Select.Option>
            )
          })}
      </Select>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/qcc/AppSelect/index.tsx